import React from 'react';
import { presetLastDays, presetYearToDate } from '../utils/defaultDateFilters';

const PRESETS = [
  { key: '7d', label: '7 дн.', fn: () => presetLastDays(7) },
  { key: '30d', label: '30 дн.', fn: () => presetLastDays(30) },
  { key: '90d', label: '90 дн.', fn: () => presetLastDays(90) },
  { key: 'ytd', label: 'Год', fn: () => presetYearToDate() },
];

export default function DateRangeFilter({ filters, onChange }) {
  const update = (key, val) => onChange({ ...filters, [key]: val });

  const applyPreset = (getRange) => {
    const r = getRange();
    onChange({ ...filters, start_date: r.start_date, end_date: r.end_date });
  };

  const handlePresetPointerDown = (e) => {
    // Иначе первый клик уходит на blur у input[type=date], и preset срабатывает только со 2-го раза.
    if (e.button === 0) e.preventDefault();
  };

  return (
    <div style={styles.bar}>
      <div style={styles.group}>
        <span style={styles.label}>Компания</span>
        <select
          style={styles.select}
          value={filters.company || ''}
          onChange={(e) => update('company', e.target.value || null)}
          aria-label="Фильтр по компании"
        >
          <option value="">Все</option>
          <option value="SNA">SNA</option>
          <option value="PLAS">PLAS</option>
        </select>
      </div>
      <div style={styles.groupGrow}>
        <span style={styles.label}>Период</span>
        <div style={styles.periodRow}>
          <div style={styles.dateRow}>
            <input
              style={styles.input}
              type="date"
              value={filters.start_date || ''}
              onChange={(e) => update('start_date', e.target.value)}
              aria-label="Дата начала периода"
            />
            <span style={styles.dash} aria-hidden>→</span>
            <input
              style={styles.input}
              type="date"
              value={filters.end_date || ''}
              onChange={(e) => update('end_date', e.target.value)}
              aria-label="Дата окончания периода"
            />
          </div>
          <div style={styles.presets} role="group" aria-label="Быстрый выбор периода">
            {PRESETS.map((p) => (
              <button
                key={p.key}
                type="button"
                className="preset-chip"
                style={styles.presetBtn}
                onPointerDown={handlePresetPointerDown}
                onClick={() => applyPreset(p.fn)}
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  bar: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 20,
    flexWrap: 'wrap',
    marginBottom: 24,
    background: 'var(--surface-sheen), var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 16,
    padding: '16px 20px',
    boxShadow: 'var(--card-rest)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
  },
  group: { display: 'flex', flexDirection: 'column', gap: 6, minWidth: 120 },
  groupGrow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    flex: '1 1 280px',
    minWidth: 0,
  },
  label: { color: 'var(--text-muted)', fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 },
  periodRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px 14px',
    width: '100%',
  },
  dateRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
    flex: '0 1 auto',
  },
  presets: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    alignItems: 'center',
    marginLeft: 'auto',
    justifyContent: 'flex-end',
  },
  presetBtn: {
    background: 'var(--bg-input)',
    color: 'var(--text-secondary)',
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '5px 10px',
    fontSize: 11,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all .15s',
    touchAction: 'manipulation',
  },
  select: {
    background: 'var(--bg-input)', color: 'var(--text-primary)',
    border: '1px solid var(--border)', borderRadius: 8,
    padding: '8px 12px', fontSize: 13, outline: 'none',
    transition: 'border-color .2s, box-shadow .15s',
  },
  input: {
    background: 'var(--bg-input)', color: 'var(--text-primary)',
    border: '1px solid var(--border)', borderRadius: 8,
    padding: '8px 12px', fontSize: 13, outline: 'none',
    colorScheme: 'var(--color-scheme)', transition: 'border-color .2s, box-shadow .15s',
  },
  dash: { color: 'var(--text-muted)', fontSize: 14, userSelect: 'none' },
};
